import {
  BookingApiBrokerAcceptPlaneRequest,
  BookingApiBrokerAcceptPlaneResponse,
  BookingApiBrokerAircraftSearchRequest,
  BookingApiBrokerAircraftSearchResponse,
  BookingApiBrokerDeclinePlaneRequest,
  BookingApiBrokerDeclinePlaneResponse,
  BookingApiBrokerSubmitRequest,
  BookingApiBrokerSubmitResponse,
  BookingApiEmptyLegListRequest,
  BookingApiEmptyLegListResponse,
  BookingApiEmptyLegListCountsResponse,
  BookingApiEmptyLegOrderRouteRequest,
  BookingApiEmptyLegOrderRouteResponse,
  BookingApiEmptyLegRequest,
  BookingApiEmptyLegResponse,
  BookingApiOrderFavoriteRequest,
  BookingApiOrderFavoriteResponse,
  BookingApiOrderListRequest,
  BookingApiOrderListResponse,
  BookingApiOrderListCountsResponse,
  BookingApiOrderRequest,
  BookingApiOrderRequestFavoriteRequest,
  BookingApiOrderRequestFavoriteResponse,
  BookingApiOrderRequestListRequest,
  BookingApiOrderRequestListResponse,
  BookingApiOrderRequestListCountsResponse,
  BookingApiOrderRequestRequest,
  BookingApiOrderRequestResponse,
  BookingApiOrderResponse,
  BookingApiOrderRouteListRequest,
  BookingApiOrderRouteListResponse, BookingApiOrderRouteRequest, BookingApiOrderRouteResponse,
  BookingApiOperatorSubmitOfferRequest,
  BookingApiOperatorSubmitOfferResponse,
} from "../../proto/generated/api_entities_pb";
import {API} from "../API";
import {BookingApiServiceClient} from "../../proto/generated/api_entities_grpc_web_pb";
import {getProxyUrl} from "../helpers/getProxyUrl";

const client = new BookingApiServiceClient(getProxyUrl(), null, null);

export class BookingApi {
  static async orderCreate(req: BookingApiOrderRequest): Promise<BookingApiOrderResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequest, BookingApiOrderResponse>(client, client.orderCreate, req, resolve, reject)
    });
  }

  static async getEmptyLegList(req: BookingApiEmptyLegListRequest): Promise<BookingApiEmptyLegListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegListRequest, BookingApiEmptyLegListResponse>(client, client.emptyLegList, req, resolve, reject)
    });
  }

  static async getEmptyLegListByCount(req: BookingApiEmptyLegListRequest): Promise<BookingApiEmptyLegListCountsResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegListRequest, BookingApiEmptyLegListCountsResponse>(client, client.emptyLegListByCount, req, resolve, reject)
    });
  }

  static async createEmptyLeg(req: BookingApiEmptyLegRequest): Promise<BookingApiEmptyLegResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegRequest, BookingApiEmptyLegResponse>(client, client.emptyLegCreate, req, resolve, reject)
    });
  }

  static async editEmptyLeg(req: BookingApiEmptyLegRequest): Promise<BookingApiEmptyLegResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegRequest, BookingApiEmptyLegResponse>(client, client.emptyLegUpdate, req, resolve, reject)
    });
  }

  static async archiveEmptyLeg(req: BookingApiEmptyLegRequest): Promise<BookingApiEmptyLegResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegRequest, BookingApiEmptyLegResponse>(client, client.emptyLegArchive, req, resolve, reject)
    });
  }

  static async deleteEmptyLeg(req: BookingApiEmptyLegRequest): Promise<BookingApiEmptyLegResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegRequest, BookingApiEmptyLegResponse>(client, client.emptyLegDelete, req, resolve, reject)
    });
  }

  static async getOrderList(req: BookingApiOrderListRequest): Promise<BookingApiOrderListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderListRequest, BookingApiOrderListResponse>(client, client.orderList, req, resolve, reject)
    });
  }

  static async getOrderListByCount(req: BookingApiOrderListRequest): Promise<BookingApiOrderListCountsResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderListRequest, BookingApiOrderListCountsResponse>(client, client.orderListByCount, req, resolve, reject)
    });
  }

  static async orderArchive(req: BookingApiOrderRequest): Promise<BookingApiOrderResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequest, BookingApiOrderResponse>(client, client.orderArchive, req, resolve, reject)
    });
  }

  static async getOrderRouteList(req: BookingApiOrderRouteListRequest): Promise<BookingApiOrderRouteListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRouteListRequest, BookingApiOrderRouteListResponse>(client, client.orderRouteList, req, resolve, reject)
    });
  }

  static async orderRouteArchive(req: BookingApiOrderRouteRequest): Promise<BookingApiOrderRouteResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRouteRequest, BookingApiOrderRouteResponse>(client, client.orderRouteArchive, req, resolve, reject)
    });
  }

  static async orderRequestCreate(req: BookingApiOrderRequestRequest): Promise<BookingApiOrderRequestResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestRequest, BookingApiOrderRequestResponse>(client, client.orderRequestCreate, req, resolve, reject)
    });
  }

  // Обновление статуса OrderRequest
  static async orderRequestUpdate(req: BookingApiOrderRequestRequest): Promise<BookingApiOrderRequestResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestRequest, BookingApiOrderRequestResponse>(client, client.orderRequestUpdate, req, resolve, reject)
    });
  }

  static async orderRequestList(req: BookingApiOrderRequestListRequest): Promise<BookingApiOrderRequestListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestListRequest, BookingApiOrderRequestListResponse>(client, client.orderRequestList, req, resolve, reject)
    });
  }

  static async getOrderRequestListByCount(req: BookingApiOrderRequestListRequest): Promise<BookingApiOrderRequestListCountsResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestListRequest, BookingApiOrderRequestListCountsResponse>(client, client.orderRequestListByCount, req, resolve, reject)
    });
  }

  static async orderRequestArchive(req: BookingApiOrderRequestRequest): Promise<BookingApiOrderRequestResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestRequest, BookingApiOrderRequestResponse>(client, client.orderRequestArchive, req, resolve, reject)
    });
  }

  static async orderList(req: BookingApiOrderListRequest): Promise<BookingApiOrderListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderListRequest, BookingApiOrderListResponse>(client, client.orderList, req, resolve, reject)
    });
  }

  // Получение похожих заказов
  static async orderSimilarList(req: BookingApiOrderListRequest): Promise<BookingApiOrderListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderListRequest, BookingApiOrderListResponse>(client, client.orderSimilarList, req, resolve, reject)
    });
  }

  // Обновление статуса связки EmptyLeg и OrderRoute
  static async emptyLegOrderRouteUpdate(req: BookingApiEmptyLegOrderRouteRequest): Promise<BookingApiEmptyLegOrderRouteResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiEmptyLegOrderRouteRequest, BookingApiEmptyLegOrderRouteResponse>(client, client.emptyLegOrderRouteUpdate, req, resolve, reject)
    });
  }

  // Обновление избранного статуса заявки на заказ
  static async orderRequestUpdateFavoriteStatus(req: BookingApiOrderRequestFavoriteRequest): Promise<BookingApiOrderRequestFavoriteResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestFavoriteRequest, BookingApiOrderRequestFavoriteResponse>(client, client.orderRequestUpdateFavoriteStatus, req, resolve, reject)
    });
  }

  // Получение похожих заявок на заказ
  static async orderRequestSimilarList(req: BookingApiOrderRequestListRequest): Promise<BookingApiOrderRequestListResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderRequestListRequest, BookingApiOrderRequestListResponse>(client, client.orderRequestSimilarList, req, resolve, reject)
    });
  }

  // Обновление избранного статуса заказа
  static async orderUpdateFavoriteStatus(req: BookingApiOrderFavoriteRequest): Promise<BookingApiOrderFavoriteResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOrderFavoriteRequest, BookingApiOrderFavoriteResponse>(client, client.orderUpdateFavoriteStatus, req, resolve, reject)
    });
  }

  // Поиск самолетов для брокера
  static async brokerAircraftSearch(req: BookingApiBrokerAircraftSearchRequest): Promise<BookingApiBrokerAircraftSearchResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiBrokerAircraftSearchRequest, BookingApiBrokerAircraftSearchResponse>(client, client.brokerAircraftSearch, req, resolve, reject)
    });
  }

  // Отправка запроса брокером
  static async brokerSubmitRequest(req: BookingApiBrokerSubmitRequest): Promise<BookingApiBrokerSubmitResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiBrokerSubmitRequest, BookingApiBrokerSubmitResponse>(client, client.brokerSubmitRequest, req, resolve, reject)
    });
  }

  // Отправка предложения оператором
  static async operatorSubmitOffer(req: BookingApiOperatorSubmitOfferRequest): Promise<BookingApiOperatorSubmitOfferResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiOperatorSubmitOfferRequest, BookingApiOperatorSubmitOfferResponse>(client, client.operatorSubmitOffer, req, resolve, reject)
    });
  }

  // Принятие предложения самолета брокером
  static async brokerAcceptPlane(req: BookingApiBrokerAcceptPlaneRequest): Promise<BookingApiBrokerAcceptPlaneResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiBrokerAcceptPlaneRequest, BookingApiBrokerAcceptPlaneResponse>(client, client.brokerAcceptPlane, req, resolve, reject)
    });
  }

  // Отклонение предложения самолета брокером
  static async brokerDeclinePlane(req: BookingApiBrokerDeclinePlaneRequest): Promise<BookingApiBrokerDeclinePlaneResponse> {
    return new Promise((resolve, reject) => {
      API.call<BookingApiBrokerDeclinePlaneRequest, BookingApiBrokerDeclinePlaneResponse>(client, client.brokerDeclinePlane, req, resolve, reject)
    });
  }
}